<template>
  <div>
    <div class="wrapper" v-if="active">
      <div class="backdrop" @click="close"></div>
      <div class="modal-wrapper">
        <component
          class="modal-component shadow"
          :is="active"
          :data="data"
          @close="close"
          @open="open"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Alert from './Alert'

import { mapState, mapMutations } from 'vuex';

export default {
  components: { Alert },
  computed: mapState({
    active: state => state.modals.active,
    data: state => state.modals.data,
  }),
  methods: mapMutations('modals', ['close', 'open'])
}
</script>

<style scoped lang="scss">
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999999999;
  display: flex;
}

.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.8);
}

.modal-wrapper {
  position: relative;
  margin: auto;
}

.modal-component {
  // background: #fff;
}
</style>
